import { VerificationStatus } from 'src/common/models/verificationModels';
import {
  MainPageRoute,
  AspspSelectPageRoute,
  VerificationPageRoute,
} from 'src/routes';

export const StatusRouteMap = new Map([
  [VerificationStatus.Started, MainPageRoute],
  [VerificationStatus.Initiated, MainPageRoute],
  [VerificationStatus.BusinessConsentGranted, AspspSelectPageRoute],
  [VerificationStatus.AspspsSelected, AspspSelectPageRoute],
  [VerificationStatus.Consent, VerificationPageRoute],
  [VerificationStatus.GatheringData, VerificationPageRoute],
  [VerificationStatus.TransactionsProcessing, VerificationPageRoute],
  [VerificationStatus.AnalyzingData, VerificationPageRoute],
  [VerificationStatus.InsufficientData, VerificationPageRoute],
  [VerificationStatus.Done, VerificationPageRoute],
  [VerificationStatus.Expired, VerificationPageRoute],
  [VerificationStatus.Failed, VerificationPageRoute],
]);
